import { useState, useContext, useEffect } from "react";
import styles from './Settings.module.css';
import { useSelector } from 'react-redux';
import { selectUsers } from '../store/usersSlice';
import { updatePassword } from "firebase/auth";
import { auth, db, getUserData } from "../../firebase";
import { ref, update } from "firebase/database";
import { reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import { Link } from 'react-router-dom';

import PasswordChangeModal from "../PasswordChangeModal/PasswordChangeModal";
import { ThemeContext } from "../../ThemeContext";

const Settings = () => {
  const user = useSelector(selectUsers);
  const [isModalOpen, setModalOpen] = useState(false);
  const { theme, setTheme } = useContext(ThemeContext);
  const [ userData, setUserData ] = useState({});
  
  useEffect(() => {
    const userInformation = async() => {
      const results = await getUserData(user.currentUser?.id);
      setUserData(results);
    }

    userInformation();
  },[user.currentUser])

  const reauthenticate = async (currentPassword) => {
    const user = auth.currentUser;
    const credential = EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    
    await reauthenticateWithCredential(user, credential);
  };

  const handlePasswordChange = async (currentPassword, newPassword) => {
  try {
    await reauthenticate(currentPassword);
    await updatePassword(auth.currentUser, newPassword);
    alert("Password changed successfully!");
  } catch (error) {
    alert("Error: " + error.message);
  }
};

const handleThemeChange = async (newTheme) => {
    setTheme(newTheme);

    // if user is logged in, save preference
    if (user.currentUser) {
      const userRef = ref(db, `users/${user.currentUser.id}`);
      await update(userRef, { theme: newTheme });
    }
  };

  return (
    <div>
      <h1 className={styles.heading}>Settings</h1>
      <div className={styles.mainContain}>
        <div className={styles.grid_container}>
          <Link to={"/settings/personalinformation"} className={styles.link}>Personal Information</Link>
          <Link to={"/settings/accountsettings"} className={styles.link}>Account</Link>
        </div>
      </div>
    </div>
  )
}

export default Settings;
